import type { ReactNode } from 'react';
import { useLocation } from '@/lib/router-compat';
import { SidebarProvider } from '@/components/ui/sidebar';
import { PUBLIC_ROUTES } from '@/lib/navigation';
import { AppSidebar } from './AppSidebar';

/** Signed-in app shell: persistent left sidebar next to the page content. */
export function AppShell({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  if (PUBLIC_ROUTES.includes(pathname)) return <>{children}</>;

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </SidebarProvider>
  );
}
